"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const rc_slider_1 = __importDefault(require("rc-slider"));
const RangeSliderView = ({ values, isDisabled, onChange, name, }) => {
    const range = values.map((item) => Number(item.value));
    const selectedRange = values
        .filter((item) => item.active)
        .map((item) => Number(item.value));
    const getMinMax = (items) => [Math.min(...items), Math.max(...items)];
    const currentRange = (selectedRange.length > 0 ? getMinMax(selectedRange) : getMinMax(range));
    const marks = range.reduce((acc, value, index) => {
        acc[index] = value;
        return acc;
    }, {});
    const [rangeState, setRangeState] = (0, react_1.useState)(currentRange);
    const handleChange = (vals) => {
        if (Array.isArray(vals)) {
            setRangeState([marks[vals[0]], marks[vals[1]]]);
        }
    };
    const handleChangeComplete = (vals) => {
        if (Array.isArray(vals)) {
            const selectedItems = values.filter((item) => (Number(item.value) >= Number(marks[vals[0]]) && Number(item.value) <= Number(marks[vals[1]])));
            onChange(selectedItems, name);
        }
    };
    const getKeyByValue = (object, value) => Number(Object.keys(object).find((key) => object[key] === value) || null);
    const getSelectedRange = [getKeyByValue(marks, rangeState[0]), getKeyByValue(marks, rangeState[1])];
    (0, react_1.useEffect)(() => {
        setRangeState(currentRange);
    }, [JSON.stringify(values)]);
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement("div", { className: "range-slider" },
            react_1.default.createElement(rc_slider_1.default, { range: true, min: 0, max: range.length - 1, onChange: handleChange, onChangeComplete: handleChangeComplete, value: getSelectedRange, disabled: isDisabled, step: null, marks: marks, handleRender: (node, handleProps) => react_1.default.cloneElement(node, {
                    children: (react_1.default.createElement(react_1.default.Fragment, null,
                        node.props.children,
                        react_1.default.createElement("div", { className: "rc-slider-handle-tooltip" },
                            marks[handleProps.value],
                            " m\u011Bs."))),
                }) }))));
};
exports.default = RangeSliderView;
